<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Профиль пользователя
      </v-card-title>
    </v-card>
    <v-card class="mt-4">
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-text-field label="Имя" v-model="form.name"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Фамилия" v-model="form.surname"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Почта" v-model="form.email"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field label="Город" v-model="form.city"></v-text-field>
          </v-col>
        </v-row>
        <v-form v-model="passValid">
          <v-row>
              <v-col cols="4">
                <v-text-field label="Старый пароль" v-model="oldPassword" :rules="passRules" type="password"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Новый пароль" v-model="newPassword" :rules="passRules" type="password"></v-text-field>
              </v-col>
            <v-col cols="4">
              <div style="display: flex; align-items: center; height: 100%">
                <v-btn @click="refreshPassword" color="primary">
                  <v-icon>
                    mdi-lock-reset
                  </v-icon>
                   Обновить пароль
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card v-if="data.partner" class="mt-4">
      <v-card-subtitle>Информация о партнере</v-card-subtitle>
      <v-card-text>
<!--        <v-img-->
<!--            :lazy-src="data.partner.logoUrl"-->
<!--            max-height="300"-->
<!--            max-width="250"-->
<!--            :src="data.partner.logoUrl"-->
<!--        ></v-img>-->
        <v-row>
          <v-col cols="3">
            <v-text-field disabled label="Наименование" v-model="data.partner.name"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field disabled label="Адрес" v-model="data.partner.address"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field disabled label="Почта" v-model="data.partner.email"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field disabled label="Описание" v-model="data.partner.description"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field disabled label="Ссылка" v-model="data.partner.link"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field disabled label="Город" v-model="data.partner.city.name"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field disabled label="Номер телефона" v-model="data.partner.phone"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>

import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: 'ProfilePage',
  data() {
    return {
      data: '',
      form: {
        name: '',
        surname: '',
        email: '',
        username: '',
        password: '',
        city: ''
      },
      oldPassword: '',
      newPassword: '',
      passRules: [
        v => v.length >= 4 || 'Пароль должен быть больше 4 символов',
      ],
      passValid: false,
    }
  },
  watch: {

  },
  mounted() {
    this.getAccountInfo()
  },
  methods: {
    async refreshPassword() {
      if (this.passValid) {
        try {
          const data = {
            newPassword: this.newPassword,
            oldPassword: this.oldPassword,
          }
          await this.$store.dispatch('auth/updatePassword', data)
          showSnackbar({
            message: "Пароль успешно обновлен!",
            color: "success",
            timeout: 3000,
          })
        } catch (e) {
          console.log(e)
          showSnackbar({
            message: "Не удалось обновить пароль!",
            color: "error",
            timeout: 3000,
          })
        } finally {
          this.oldPassword = ''
          this.newPassword = ''
        }
      }
    },
    async getAccountInfo () {
      try {
        const data = await this.$store.dispatch('auth/getAccountInfo')
        this.data = data
        for (let key in this.form) {
          this.form[key] = data[key]
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style scoped>

</style>